import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TermoEtapaCicloService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.fullApiUrl}/termo-etapa-ciclo`;

  findByCiclo(cicloId: number, etapaParametrizacaoId: number): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl, {
      params: { cicloId: cicloId.toString(), etapaParametrizacaoId: etapaParametrizacaoId.toString() },
    });
  }
}
